import { authTokenKey } from 'authProvider';
import { fetchUtils } from 'react-admin';
import { HOST, ORG_ID } from '../config';
import restClient from './base-rest-client';

const fetchJson = async (url, options = {}) => {
  const token = localStorage.getItem(authTokenKey);
  options.headers = new Headers({
    Authorization: `Bearer ${token}`,
    Accept: 'application/json',
  });
  return fetchUtils.fetchJson(url, options).catch((e) => {
    throw new Error(e?.body?.error || e.message);
  });
};
export default restClient(`${HOST}${(ORG_ID ? `/org/${ORG_ID}` : '')}`, fetchJson);
